/**
 * 터치 제스처(pan / pinch) 좌표 계산 유틸.
 * 이미지 크게보기 뷰어 등 확대·이동이 필요한 화면에서 공용으로 쓴다.
 */

export type Point = { x: number; y: number };

/** Touch 의 뷰포트 기준 좌표. */
export const getTouchPoint = (touch: Touch): Point => ({
  x: touch.clientX,
  y: touch.clientY,
});

/** 두 손가락 사이 거리(px). 핀치 배율 계산의 기준값. */
export const getTouchesDistance = (a: Touch, b: Touch): number =>
  Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY);

/** 두 손가락의 중점(뷰포트 기준). 핀치 확대의 고정점. */
export const getTouchesCenter = (a: Touch, b: Touch): Point => ({
  x: (a.clientX + b.clientX) / 2,
  y: (a.clientY + b.clientY) / 2,
});

/** 뷰포트 좌표를 특정 엘리먼트(offsetParent) 내부 좌표로 변환. */
export const toLocalPoint = (point: Point, rect: DOMRect): Point => ({
  x: point.x - rect.left,
  y: point.y - rect.top,
});

/** value 를 [min, max] 범위로 제한. */
export const clamp = (value: number, min: number, max: number): number =>
  Math.min(Math.max(value, min), max);
